import EventAdaptingStateHandler from "src/states/EventAdaptingStateHandler"
import StateConstants from "src/states/StateContstants"


class UserFeatureHelper {
    static ALL_COMPARABLES = "all_comparables"
    static REMOVE_COMPARABLES = "remove_comparables"
    static DISTANCE_FILTER = "distance_filter"
    static PROPERTY_TYPE_FILTER = "property_type_filter"
    static SALE_RECENCY_FILTER = "sale_recency_filter"
    static ALL_TIME_CHART = "all_time_chart"
    static DETAILED_VALUATIONS = "detailed_valuations"
    static UNLIMITED_DETAILED_VALUATIONS = "unlimited_detailed_valuations"
    static PRICE_FORECASTING = "price_forecasting"
    static PDF_REPORT = "pdf_report"

    static hasFeature(stateHandler: EventAdaptingStateHandler, feature: string): boolean {
        const features: string[] = stateHandler.get(StateConstants.USER_FEATURES) || []
        return features.includes(feature)
    }
}

export default UserFeatureHelper
